import { useLocation, useNavigate } from "react-router-dom";
import Wordmark from "@/components/Logo";
import { scrollToSection, waLink } from "@/lib/scroll";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const go = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToSection(id), 400);
    } else {
      scrollToSection(id);
    }
  };
  return (
  <footer data-testid="footer" className="bg-[#151A1F] border-t border-white/10 overflow-hidden">
    <div className="mx-auto max-w-7xl px-6 sm:px-10 pt-16 sm:pt-20">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <Wordmark tone="light" className="text-2xl" />
          <p className="mt-4 text-sm text-[#F6F7F5]/55 leading-relaxed max-w-xs">
            Aplicación agrícola con drones en Santa Cruz de la Sierra, Bolivia.
          </p>
        </div>
        <div>
          <p className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#F6F7F5]/40">Secciones</p>
          <div className="mt-4 flex flex-col gap-3">
            {["servicios", "zonas", "protocolo", "nosotros", "cotizar"].map((id) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => scrollToSection(id)}
                className="text-left text-sm text-[#F6F7F5]/70 hover:text-[#00A651] transition-colors capitalize w-fit"
              >
                {id}
              </button>
            ))}
          </div>
        </div>
        <div>
          <p className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#F6F7F5]/40">Contacto</p>
          <div className="mt-4 flex flex-col gap-3 text-sm text-[#F6F7F5]/70">
            <a
              data-testid="footer-whatsapp-link"
              href={waLink("Hola Fumiga, quiero cotizar aplicación con dron.")}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00A651] transition-colors w-fit"
            >
              WhatsApp directo
            </a>
            <a data-testid="footer-instagram-link" href="https://instagram.com/fumigasrl" target="_blank" rel="noopener noreferrer" className="hover:text-[#00A651] transition-colors w-fit">
              Instagram · @fumigasrl
            </a>
            <a data-testid="footer-facebook-link" href="https://facebook.com/fumigasrl" target="_blank" rel="noopener noreferrer" className="hover:text-[#00A651] transition-colors w-fit">
              Facebook · @fumigasrl
            </a>
            <a data-testid="footer-tiktok-link" href="https://www.tiktok.com/@fumigasrl" target="_blank" rel="noopener noreferrer" className="hover:text-[#00A651] transition-colors w-fit">
              TikTok · @fumigasrl
            </a>
          </div>
        </div>
      </div>

      <div className="mt-16 select-none pointer-events-none" aria-hidden="true">
        <p className="font-wordmark font-bold text-[22vw] leading-[0.85] text-[#F6F7F5]/[0.045] text-center whitespace-nowrap">
          FUMIGA
        </p>
      </div>

      <div className="border-t border-white/10 py-6 flex flex-wrap items-center justify-between gap-4 font-mono-tech text-[10px] uppercase tracking-[0.2em] text-[#F6F7F5]/35">
        <span>© 2026 Fumiga · Santa Cruz de la Sierra</span>
        <span>Deriva Calibrada v1.0</span>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
